import LogoAriston from "../../../../images/content/introduction/direct-members/logo-ariston.jpg";
import LogoBeko from "../../../../images/content/introduction/direct-members/logo-beko.jpg";
import LogoBSH from "../../../../images/content/introduction/direct-members/logo-bsh.jpg";
import LogoDaikin from "../../../../images/content/introduction/direct-members/logo-daikin.jpg";
import LogoDelonghi from "../../../../images/content/introduction/direct-members/logo-delonghi.jpg";
import LogoDyson from "../../../../images/content/introduction/direct-members/logo-dyson.jpg";
import LogoElectrolux from "../../../../images/content/introduction/direct-members/logo-electrolux.jpg";
import LogoGroupeAtlantic from "../../../../images/content/introduction/direct-members/logo-groupe-atlantic.jpg";
import LogoHaier from "../../../../images/content/introduction/direct-members/logo-haier.jpg";
import LogoHisense from "../../../../images/content/introduction/direct-members/logo-hisense.jpg";
import LogoIrobot from "../../../../images/content/introduction/direct-members/logo-irobot.jpg";
import LogoKitchenAid from "../../../../images/content/introduction/direct-members/logo-kitchenaid.jpg";
import LogoLG from "../../../../images/content/introduction/direct-members/logo-lg.jpg";
import LogoLiebherr from "../../../../images/content/introduction/direct-members/logo-liebherr.jpg";
import LogoMidea from "../../../../images/content/introduction/direct-members/logo-midea.jpg";
import LogoMiele from "../../../../images/content/introduction/direct-members/logo-miele.jpg";
import LogoPanasonic from "../../../../images/content/introduction/direct-members/logo-panasonic.jpg";
import LogoPhilips from "../../../../images/content/introduction/direct-members/logo-philips.jpg";
import LogoPG from "../../../../images/content/introduction/direct-members/logo-pg.jpg";
import LogoSamsung from "../../../../images/content/introduction/direct-members/logo-samsung.jpg";
import LogoGroupeSEB from "../../../../images/content/introduction/direct-members/logo-groupe-seb.jpg";
import LogoSmeg from "../../../../images/content/introduction/direct-members/logo-smeg.jpg";
import LogoVersuni from "../../../../images/content/introduction/direct-members/logo-versuni.jpg";
import LogoVestel from "../../../../images/content/introduction/direct-members/logo-vestel.jpg";
import LogoVorwerk from "../../../../images/content/introduction/direct-members/logo-vorwerk.jpg";

export const directMembers = [
	{
		id: "applia-member-ariston-group",
		url: "https://www.aristongroup.com/en/",
		imageUrl: LogoAriston,
		imageAlt: "Ariston logo",
	},
	{
		id: "applia-member-beko",
		url: "https://www.bekoeurope.com/",
		imageUrl: LogoBeko,
		imageAlt: "Beko logo",
	},
	{
		id: "applia-member-bsh",
		url: "https://www.bsh-group.com/",
		imageUrl: LogoBSH,
		imageAlt: "BSH logo",
	},
	{
		id: "applia-member-daikin",
		url: "https://www.daikin.eu/en_us/customers.html",
		imageUrl: LogoDaikin,
		imageAlt: "Daikin logo",
	},
	{
		id: "applia-member-delonghi",
		url: "https://www.delonghigroup.com/en",
		imageUrl: LogoDelonghi,
		imageAlt: "Delonghi logo",
	},
	{
		id: "applia-member-dyson",
		url: "https://www.dyson.co.uk/",
		imageUrl: LogoDyson,
		imageAlt: "Dyson logo",
	},
	{
		id: "applia-member-electrolux",
		url: "https://www.electroluxgroup.com/en/",
		imageUrl: LogoElectrolux,
		imageAlt: "Electrolux logo",
	},
	{
		id: "applia-member-groupe-atlantic",
		url: "https://www.groupe-atlantic.fr/en/",
		imageUrl: LogoGroupeAtlantic,
		imageAlt: "Groupe Atlantic logo",
	},
	{
		id: "applia-member-haier",
		url: "https://corporate.haier-europe.com/en/",
		imageUrl: LogoHaier,
		imageAlt: "Haier logo",
	},
	{
		id: "applia-member-hisense",
		url: "https://www.hisense-europe.com/en/",
		imageUrl: LogoHisense,
		imageAlt: "Hisense logo",
	},
	{
		id: "applia-member-irobot",
		url: "https://www.irobot.com/",
		imageUrl: LogoIrobot,
		imageAlt: "iRobot logo",
	},
	{
		id: "applia-member-kitchenaid",
		url: "https://www.irobot.com/",
		imageUrl: LogoKitchenAid,
		imageAlt: "KitchenAid logo",
	},
	{
		id: "applia-member-LG",
		url: "https://www.lg.com/global/",
		imageUrl: LogoLG,
		imageAlt: "LG logo",
	},
	{
		id: "applia-member-liebherr",
		url: "https://www.liebherr.com",
		imageUrl: LogoLiebherr,
		imageAlt: "Liebherr logo",
	},
	{
		id: "applia-member-midea",
		url: "https://www.midea.com/de/",
		imageUrl: LogoMidea,
		imageAlt: "Midea logo",
	},
	{
		id: "applia-member-miele",
		url: "https://www.miele.de",
		imageUrl: LogoMiele,
		imageAlt: "Miele logo",
	},
	{
		id: "applia-member-panasonic",
		url: "https://www.panasonic.eu",
		imageUrl: LogoPanasonic,
		imageAlt: "Panasonic logo",
	},
	{
		id: "applia-member-philips",
		url: "https://www.philips.com",
		imageUrl: LogoPhilips,
		imageAlt: "Philips logo",
	},
	{
		id: "applia-member-procter-and-gamble",
		url: "https://fr-be.pg.com/",
		imageUrl: LogoPG,
		imageAlt: "P&G logo",
	},
	{
		id: "applia-member-samsung",
		url: "https://www.samsung.com",
		imageUrl: LogoSamsung,
		imageAlt: "Samsung logo",
	},
	{
		id: "applia-member-groupe-seb",
		url: "https://www.groupeseb.com",
		imageUrl: LogoGroupeSEB,
		imageAlt: "SEB logo",
	},
	{
		id: "applia-member-smeg",
		url: "https://www.smeg.com",
		imageUrl: LogoSmeg,
		imageAlt: "Smeg logo",
	},
	{
		id: "applia-member-versuni",
		url: "https://www.versuni.com",
		imageUrl: LogoVersuni,
		imageAlt: "Versuni logo",
	},
	{
		id: "applia-member-vestel",
		url: "https://www.vestel.com/",
		imageUrl: LogoVestel,
		imageAlt: "Vestel logo",
	},
	{
		id: "applia-member-vorwerk",
		url: "https://www.vorwerk.com",
		imageUrl: LogoVorwerk,
		imageAlt: "Vorwerk logo",
	},
];
